import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { useNavigate, useLocation } from "react-router-dom";
import TaskBoardColumn from "./newTaskBoard/TaskBoardColumn";
import { Box, Button, Typography } from "@mui/material";
import { fetchData } from "../Utils/Baseurl";
import { useLoading } from "../../context/loadingcontext";
import MaterialButton from "../../components/MaterialButton";

const NewTaskBoard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setCirleLoading } = useLoading();
  const [data, setData] = useState([]);

  const id = location?.state?.id;
  const projectName = location?.state?.projectName;

  useEffect(() => {
    if (id) {
      fetchProjectList();
    }
  }, []);

  const fetchProjectList = async () => {
    setCirleLoading(true);
    try {
      const result = await fetchData(`api/grouped-tasks/${id}/`);
      setData(result);
    } finally {
      setCirleLoading(false);
    }
  };

  const handleAddTask = () => {
    navigate("/task-creation/add-task-creation"); // Adjust route as per your app
  };

  return (
    <DashboardLayout>
      <Box sx={{ padding: "20px" }}>
        {data.length === 0 ? (
          <Box
            sx={{
              height: "60vh",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              border: "2px dashed #ccc",
              borderRadius: "16px",
              backgroundColor: "#f9f9f9",
              padding: "40px",
              textAlign: "center",
            }}
          >
            <Typography variant="h6" color="text.secondary" sx={{ mb: 2 }}>
              No tasks available yet.
            </Typography>

            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={handleAddTask}
            >
              Add Task Creation
            </MaterialButton>
          </Box>
        ) : (
          <>
            <h1
              style={{
                fontSize: "1.2rem",
                fontWeight: "600",
                color: "#2c3e50",
                margin: "0 0 12px 0",
                letterSpacing: "1px",
                textTransform: "uppercase",
              }}
            >
              {projectName}
            </h1>
            {data?.map((val, index) => (
              <TaskBoardColumn
                key={index}
                index={index}
                mileStoneName={val?.milestone}
                sprints={val?.sprints}
              />
            ))}
          </>
        )}
      </Box>
    </DashboardLayout>
  );
};

export default NewTaskBoard;
